import { Component, Directive, ElementRef, inject, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'report-templates-directive',
  standalone: false
})
export class ReportTemplatesDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('reportTemplatesComponent', elementRef, injector);
  }
}

@Component({
  selector: 'report-templates-component',
  template: '<report-templates-directive></report-templates-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportTemplatesComponent {}

@Directive({
  selector: 'report-run-directive',
  standalone: false
})
export class ReportRunDirective extends UpgradeComponent {
  @Input() reportId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('reportRunComponent', elementRef, injector);
  }
}

@Component({
  selector: 'report-run-component',
  template: '<report-run-directive [reportId]="reportId"></report-run-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportRunComponent {
  @Input() reportId: string;
}

@Directive({
  selector: 'report-template-form-directive',
  standalone: false
})
export class ReportTemplateFormDirective extends UpgradeComponent {
  @Input() reportId: string;
  @Input() action: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('reportTemplateComponent', elementRef, injector);
  }
}

@Component({
  selector: 'report-template-form-component',
  template: '<report-template-form-directive [reportId]="reportId" [action]="action"></report-template-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportTemplateFormComponent {
  @Input() reportId: string;

  protected action: string;
  private route = inject(ActivatedRoute);

  constructor() {
    this.route.data.subscribe(data => {
      this.action = data['action'];
    });
  }
}

@Directive({
  selector: 'multi-report-edit-element-directive',
  standalone: false
})
export class MultiReportEditElementDirective extends UpgradeComponent {
  @Input() reportId: string;
  @Input() elementId: string;
  @Input() action: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('multiReportEditElementComponent', elementRef, injector);
  }
}

@Component({
  selector: 'multi-report-edit-element-component',
  template: '<multi-report-edit-element-directive [reportId]="reportId" [elementId]="elementId" [action]="action"></multi-report-edit-element-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MultiReportEditElementComponent {
  @Input() reportId: string;
  @Input() elementId: string;
  @Input() action: string;
}

@Directive({
  selector: 'report-wrapper-directive',
  standalone: false
})
export class ReportWrapperDirective extends UpgradeComponent {
  @Input() showActionButtons: boolean;
  @Input() user: string;
  @Input() blueprintId: string;
  @Input() blueprintCatId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('reportWrapperComponent', elementRef, injector);
  }
}

@Component({
  selector: 'report-wrapper-component',
  template: '<report-wrapper-directive [showActionButtons]="showActionButtons" [user]="user" [blueprintId]="blueprintId" [blueprintCatId]="blueprintCatId"></report-wrapper-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportWrapperComponent {
  @Input() showActionButtons: boolean;
  @Input() user: string;
  @Input() blueprintId: string;
  @Input() blueprintCatId: string;
}
